import type { User } from "firebase/auth";

// Every job write from the app says who made it, so the job log can name
// them ("Type: Service → Warranty · Brandon"). Rules only accept your own uid.
export function editStamp(user: Pick<User, "uid" | "displayName" | "email"> | null): {
  updatedAt: number;
  editedBy?: { uid: string; name: string; at: number };
} {
  const at = Date.now();
  if (!user) return { updatedAt: at };
  return { updatedAt: at, editedBy: { uid: user.uid, name: user.displayName || user.email || "Team member", at } };
}
